import { AuthGuard } from '@shared/auth/auth.guard';
import { activeRoleGuard } from '@shared/auth/active-role.guard';

// Gestion des organismes : administrateur application ou administrateur d'organisme.
export const RouteMeta = {
    canActivate: [AuthGuard, activeRoleGuard],
    data: { roles: ['ROLE_APP_ADMIN', 'ROLE_ORG_ADMIN'] }
};
